module.exports = {
    orderConfirmation: {
        pickupMessage: 'Your order can be collected from',
        deliveryMessage: 'Your order will be delivered to',

        orderConfirmedMessage: 'Order confirmed',
        orderCancelledMessage: 'Order cancelled',

        orderConfirmedAdditionalMessage: 'Thanks for shopping with Woolworths!',
        orderCancelledAdditionalMessage: 'The order value will be refunded to you soon!',

        // For the delivery details section header
        courierDeliveryDetailsHeader: 'DELIVERY ORDER DETAILS',
        expressDeliveryDetailsHeader: 'YOUR ORDER WILL BE DELIVERED',
        pickupDeliveryDetailsHeader: 'PICK UP ORDER DETAILS',

        // For the order confirmation header
        courierOrderConfirmationHeader: 'Delivery',
        expressDeliveryOrderConfirmationHeader: 'Express Delivery',
        pickupDeliveryOrderConfirmationHeader: 'Pick up',

        // Different delivery methods for the order
        courierDeliveryMethod: 'Courier',
        expressDeliveryMethod: 'XpressD',
        pickupDeliveryMethod: 'Pickup',
        hubspokDeliveryMethod: 'HubSpok',

        // Payment Breakdown Key
        creditCardKey: 'CreditCard',
        paypalKey: 'PayPal',
        giftCardKey: 'GiftCard',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/order-confirmation.js